import { fg } from '@atlassian/jira-feature-gating';
import { uifBacklogResource } from '@atlassian/jira-router-resources-uif-backlog/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { boardDataResource } from './data-api/index.tsx';
import { rapidboardResource } from './rapidboard-resource/index.tsx';
import { wrmBundleResource } from './wrm-bundle/index.tsx';

export const shouldLoadUIFBoardResources = () => !__SERVER__;
export const shouldLoadLegacyBoardResources = () => !shouldLoadUIFBoardResources();

export const getRapidboardResources = () => [
	wrmBundleResource,
	resourceWithCondition2(shouldLoadLegacyBoardResources, rapidboardResource),
];

export const getRapidBoardDataResource = () => boardDataResource;

export const getUIFBacklogDataResource = (isUserOrEmbedBacklog = false) => [
	resourceWithCondition2(
		() =>
			(shouldLoadUIFBoardResources() || fg('enable_ssr_for_cmp_backlog')) &&
			(isUserOrEmbedBacklog || !fg('backlog_relay_data_resource')),
		uifBacklogResource,
	),
];
